const KEY = 'employee_opt_out_code';
const VALUE = '33';

/* Employees can opt out permanently of analytics. */
export function isEmployeeAndOptedOut() {
  try {
    return localStorage.getItem(KEY) === VALUE;
  } catch (_) {
    return false;
  }
}

export function optOutEmployee() {
  try {
    localStorage.setItem(KEY, VALUE);
  } catch (_) {
    console.log('Failed to opt-out employee.');
  }
}
